import SendButton from "./send_button";
import LoadButton from "./load_button";
import { useSelector } from "react-redux";

const SendFileButton = () => {
  const fileDetails = useSelector(state => state.fileDetails);
  return (
    <>
      {fileDetails.load ? <LoadButton key="loading" /> : <SendButton key="send" />}
    </>
  );
};

export default SendFileButton;
